import dayjs from 'dayjs'

/**
 * Format a date value for export as YYYY-MM-DD.
 * Returns the original value if null, empty, or invalid.
 */
export function formatDateForExport(val: unknown): unknown {
  if (val == null || val === '') return val
  const parsed = dayjs(val as string | number | Date)
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : val
}

/**
 * Get the raw value key from a value_key that may have _fmt suffix.
 * e.g. cost_basis_fmt -> cost_basis, funds__name -> funds__name
 */
export function getRawValueKey(valueKey: string): string {
  return valueKey.endsWith('_fmt') ? valueKey.replace(/_fmt$/, '') : valueKey
}
